var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { padding: "20px" }, attrs: { id: "app-details-view" } },
    [
      _c("h2", [
        !_vm.app.preview
          ? _c("div", { staticClass: "icon-settings-dark" })
          : _vm._e(),
        _vm._v(" "),
        _vm.app.previewAsIcon && _vm.app.preview
          ? _c(
              "svg",
              { attrs: { width: "32", height: "32", viewBox: "0 0 32 32" } },
              [
                _c("defs", [
                  _c(
                    "filter",
                    { attrs: { id: _vm.filterId } },
                    [
                      _c("feColorMatrix", {
                        attrs: {
                          in: "SourceGraphic",
                          type: "matrix",
                          values: "-1 0 0 0 1 0 -1 0 0 1 0 0 -1 0 1 0 0 0 1 0"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("image", {
                  staticClass: "app-icon",
                  attrs: {
                    x: "0",
                    y: "0",
                    width: "32",
                    height: "32",
                    preserveAspectRatio: "xMinYMin meet",
                    filter: _vm.filterUrl,
                    "xlink:href": _vm.app.preview
                  }
                })
              ]
            )
          : _vm._e(),
        _vm._v("\n\t\t" + _vm._s(_vm.app.name) + "\n\t")
      ]),
      _vm._v(" "),
      _vm.app.screenshot
        ? _c("img", { attrs: { src: _vm.app.screenshot, width: "100%" } })
        : _vm._e(),
      _vm._v(" "),
      _vm.app.level === 300 || _vm.app.level === 200 || _vm.hasRating
        ? _c(
            "div",
            { staticClass: "app-level" },
            [
              _vm.app.level === 300
                ? _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip.auto",
                          value: _vm.t(
                            "settings",
                            "This app is supported via your current Nextcloud subscription."
                          ),
                          expression:
                            "t('settings', 'This app is supported via your current Nextcloud subscription.')",
                          modifiers: { auto: true }
                        }
                      ],
                      staticClass: "supported icon-checkmark-color"
                    },
                    [
                      _vm._v(
                        "\n\t\t\t" + _vm._s(_vm.t("settings", "Supported"))
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.app.level === 200
                ? _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip.auto",
                          value: _vm.t(
                            "settings",
                            "Featured apps are developed by and within the community. They offer central functionality and are ready for production use."
                          ),
                          expression:
                            "t('settings', 'Featured apps are developed by and within the community. They offer central functionality and are ready for production use.')",
                          modifiers: { auto: true }
                        }
                      ],
                      staticClass: "official icon-checkmark"
                    },
                    [_vm._v("\n\t\t\t" + _vm._s(_vm.t("settings", "Featured")))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasRating
                ? _c("AppScore", {
                    attrs: { score: _vm.app.appstoreData.ratingOverall }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.author
        ? _c(
            "div",
            { staticClass: "app-author" },
            [
              _vm._v("\n\t\t" + _vm._s(_vm.t("settings", "by")) + "\n\t\t"),
              _vm._l(_vm.author, function(a, index) {
                return _c("span", { key: index }, [
                  a["@attributes"] && a["@attributes"]["homepage"]
                    ? _c(
                        "a",
                        { attrs: { href: a["@attributes"]["homepage"] } },
                        [_vm._v(_vm._s(a["@value"]))]
                      )
                    : a["@value"]
                    ? _c("span", [_vm._v(_vm._s(a["@value"]))])
                    : _c("span", [_vm._v(_vm._s(a))]),
                  index + 1 < _vm.author.length
                    ? _c("span", [_vm._v(", ")])
                    : _vm._e()
                ])
              })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.licence
        ? _c("div", { staticClass: "app-licence" }, [
            _vm._v("\n\t\t" + _vm._s(_vm.licence) + "\n\t")
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "actions" }, [
        _c("div", { staticClass: "actions-buttons" }, [
          _vm.app.update
            ? _c("input", {
                staticClass: "update primary",
                attrs: {
                  type: "button",
                  value: _vm.t("settings", "Update to {version}", {
                    version: _vm.app.update
                  }),
                  disabled: _vm.installing || _vm.loading(_vm.app.id)
                },
                on: {
                  click: function($event) {
                    return _vm.update(_vm.app.id)
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.app.canUnInstall
            ? _c("input", {
                staticClass: "uninstall",
                attrs: {
                  type: "button",
                  value: _vm.t("settings", "Remove"),
                  disabled: _vm.installing || _vm.loading(_vm.app.id)
                },
                on: {
                  click: function($event) {
                    return _vm.remove(_vm.app.id)
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.app.active
            ? _c("input", {
                staticClass: "enable",
                attrs: {
                  type: "button",
                  value: _vm.t("settings", "Disable"),
                  disabled: _vm.installing || _vm.loading(_vm.app.id)
                },
                on: {
                  click: function($event) {
                    return _vm.disable(_vm.app.id)
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.app.active && (_vm.app.canInstall || _vm.app.isCompatible)
            ? _c("input", {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip.auto",
                    value: _vm.enableButtonTooltip,
                    expression: "enableButtonTooltip",
                    modifiers: { auto: true }
                  }
                ],
                staticClass: "enable primary",
                attrs: {
                  type: "button",
                  value: _vm.enableButtonText,
                  disabled:
                    !_vm.app.canInstall ||
                    _vm.installing ||
                    _vm.loading(_vm.app.id)
                },
                on: {
                  click: function($event) {
                    return _vm.enable(_vm.app.id)
                  }
                }
              })
            : !_vm.app.active
            ? _c("input", {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip.auto",
                    value: _vm.forceEnableButtonTooltip,
                    expression: "forceEnableButtonTooltip",
                    modifiers: { auto: true }
                  }
                ],
                staticClass: "enable force",
                attrs: {
                  type: "button",
                  value: _vm.forceEnableButtonText,
                  disabled: _vm.installing || _vm.loading(_vm.app.id)
                },
                on: {
                  click: function($event) {
                    return _vm.forceEnable(_vm.app.id)
                  }
                }
              })
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "app-groups" }, [
          _vm.app.active && _vm.canLimitToGroups(_vm.app)
            ? _c(
                "div",
                { staticClass: "groups-enable" },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.groupCheckedAppsData,
                        expression: "groupCheckedAppsData"
                      }
                    ],
                    staticClass: "groups-enable__checkbox checkbox",
                    attrs: {
                      id: _vm.prefix("groups_enable", _vm.app.id),
                      type: "checkbox"
                    },
                    domProps: {
                      value: _vm.app.id,
                      checked: Array.isArray(_vm.groupCheckedAppsData)
                        ? _vm._i(_vm.groupCheckedAppsData, _vm.app.id) > -1
                        : _vm.groupCheckedAppsData
                    },
                    on: {
                      change: [
                        function($event) {
                          var $$a = _vm.groupCheckedAppsData,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = _vm.app.id,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                (_vm.groupCheckedAppsData = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.groupCheckedAppsData = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.groupCheckedAppsData = $$c
                          }
                        },
                        _vm.setGroupLimit
                      ]
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    { attrs: { for: _vm.prefix("groups_enable", _vm.app.id) } },
                    [_vm._v(_vm._s(_vm.t("settings", "Limit to groups")))]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    staticClass: "group_select",
                    attrs: {
                      type: "hidden",
                      title: _vm.t("settings", "All"),
                      value: ""
                    }
                  }),
                  _vm._v(" "),
                  _vm.isLimitedToGroups(_vm.app)
                    ? _c(
                        "Multiselect",
                        {
                          staticClass: "multiselect-vue",
                          attrs: {
                            options: _vm.groups,
                            value: _vm.appGroups,
                            "options-limit": 5,
                            placeholder: _vm.t(
                              "settings",
                              "Limit app usage to groups"
                            ),
                            label: "name",
                            "track-by": "id",
                            multiple: true,
                            "close-on-select": false,
                            "tag-width": 60
                          },
                          on: {
                            select: _vm.addGroupLimitation,
                            remove: _vm.removeGroupLimitation,
                            "search-change": _vm.asyncFindGroup
                          }
                        },
                        [
                          _c(
                            "span",
                            { attrs: { slot: "noResult" }, slot: "noResult" },
                            [_vm._v(_vm._s(_vm.t("settings", "No results")))]
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("ul", { staticClass: "app-dependencies" }, [
        _vm.app.missingMinOwnCloudVersion
          ? _c("li", [
              _vm._v(
                "\n\t\t\t" +
                  _vm._s(
                    _vm.t(
                      "settings",
                      "This app has no minimum Nextcloud version assigned. This will be an error in the future."
                    )
                  ) +
                  "\n\t\t"
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.app.missingMaxOwnCloudVersion
          ? _c("li", [
              _vm._v(
                "\n\t\t\t" +
                  _vm._s(
                    _vm.t(
                      "settings",
                      "This app has no maximum Nextcloud version assigned. This will be an error in the future."
                    )
                  ) +
                  "\n\t\t"
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        !_vm.app.canInstall
          ? _c("li", [
              _vm._v(
                "\n\t\t\t" +
                  _vm._s(
                    _vm.t(
                      "settings",
                      "This app cannot be installed because the following dependencies are not fulfilled:"
                    )
                  ) +
                  "\n\t\t\t"
              ),
              _c(
                "ul",
                { staticClass: "missing-dependencies" },
                _vm._l(_vm.app.missingDependencies, function(dep, index) {
                  return _c("li", { key: index }, [
                    _vm._v("\n\t\t\t\t\t" + _vm._s(dep) + "\n\t\t\t\t")
                  ])
                }),
                0
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "documentation" }, [
        !_vm.app.internal
          ? _c(
              "a",
              {
                staticClass: "appslink",
                attrs: {
                  href: _vm.appstoreUrl,
                  target: "_blank",
                  rel: "noreferrer noopener"
                }
              },
              [_vm._v(_vm._s(_vm.t("settings", "View in store")) + " ↗")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.app.website
          ? _c(
              "a",
              {
                staticClass: "appslink",
                attrs: {
                  href: _vm.app.website,
                  target: "_blank",
                  rel: "noreferrer noopener"
                }
              },
              [_vm._v(_vm._s(_vm.t("settings", "Visit website")) + " ↗")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.app.bugs
          ? _c(
              "a",
              {
                staticClass: "appslink",
                attrs: {
                  href: _vm.app.bugs,
                  target: "_blank",
                  rel: "noreferrer noopener"
                }
              },
              [_vm._v(_vm._s(_vm.t("settings", "Report a bug")) + " ↗")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.app.documentation && _vm.app.documentation.user
          ? _c(
              "a",
              {
                staticClass: "appslink",
                attrs: {
                  href: _vm.app.documentation.user,
                  target: "_blank",
                  rel: "noreferrer noopener"
                }
              },
              [_vm._v(_vm._s(_vm.t("settings", "User documentation")) + " ↗")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.app.documentation && _vm.app.documentation.admin
          ? _c(
              "a",
              {
                staticClass: "appslink",
                attrs: {
                  href: _vm.app.documentation.admin,
                  target: "_blank",
                  rel: "noreferrer noopener"
                }
              },
              [_vm._v(_vm._s(_vm.t("settings", "Admin documentation")) + " ↗")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.app.documentation && _vm.app.documentation.developer
          ? _c(
              "a",
              {
                staticClass: "appslink",
                attrs: {
                  href: _vm.app.documentation.developer,
                  target: "_blank",
                  rel: "noreferrer noopener"
                }
              },
              [
                _vm._v(
                  _vm._s(_vm.t("settings", "Developer documentation")) + " ↗"
                )
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", {
        staticClass: "app-description",
        domProps: { innerHTML: _vm._s(_vm.renderMarkdown) }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }